import { eachMonthOfInterval, format } from 'date-fns';

/**
 * Return a string array of months between two date ranges.
 *
 * @param startDate Start date
 * @param end End date
 * @returns Array of months between the two dates
 */
const getMonthsInRange = (start: Date, end: Date): string[] => {
  const months = eachMonthOfInterval({ start, end });
  return months.map((month) => format(month, 'MMMM'));
};

export default getMonthsInRange;
